import actionTypes from './actionTypes';

const requestPPTData = (args) => ({
    type: actionTypes.REQUEST_PPT_DATA,
    payload: args,
});

const gameDataResponse = (success, errors, response) => ({
    type: actionTypes.GAME_DATA_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

const pptDataResponse = (success, errors, response) => ({
    type: actionTypes.PPT_DATA_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

const teamDataResponse = (success, errors, response) => ({
    type: actionTypes.TEAM_DATA_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    gameDataResponse,
    requestPPTData,
    pptDataResponse,
    teamDataResponse,
};
